export const normalizeTop = (rawData) => {
  return {
    titleList: rawData?.title_list ?? [],
    bgColor: rawData?.bg_color ?? '',
    button: rawData?.button ?? '',
    pageCount: rawData?.page_count ?? '',
    count: rawData?.count ?? '',
  }
}

export const normalizeImage = (rawData) => {
  return {
    thumbnail: rawData?.thumbnail ?? '',
    bannerBackground: rawData?.banner_background ?? '',
    banner_layer: rawData?.banner_layer ?? '',
  }
}

export const normalizeRank = (rawData) => {
  return {
    order: rawData?.order ?? '',
    thumbnail: rawData?.thumbnail ?? '',
  }
}
export const normalizeTag = (rawData) => {
  return {
    topList: rawData?.top_list ?? [],
    brandList: rawData?.brand_list ?? [],
    updateList: rawData?.update_list ?? [],
  }
}

export const normalizeContextProperty = (rawData) => {
  return {
    type: rawData?.type ?? '',
    contentId: rawData?.content_id ?? '',
    description: rawData?.description ?? '',
    top: normalizeTop(rawData?.top),
    titleList: rawData?.title_list ?? [],
    metaTitleList: rawData?.meta_title_list ?? '',
    alt: rawData?.alt ?? '',
    image: normalizeImage(rawData?.image),
    bgColor: rawData?.bg_color ?? '',
    age: rawData?.age ?? '',
    likeStatus: rawData?.like_status ?? '',
    progress: rawData?.progress ?? '',
    cta: rawData?.cta ?? '',
    rank: normalizeRank(rawData?.rank),
    tag: normalizeTag(rawData?.tag),
  }
}
